// extracted by mini-css-extract-plugin
module.exports = {"form":"LayerInput_form__3qNED","buttons":"LayerInput_buttons__16iHP","add":"LayerInput_add__1069D","cancel":"LayerInput_cancel__Er-wo"};